var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert",class:['scheme--' + _vm.type, {'alert--has-icon': _vm.icon}]},[(_vm.icon)?_c('Icon',{staticClass:"warning"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('div',{staticClass:"alert__body"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }